









import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class AccountIcon extends Vue {
  @Prop({ type: Number, default: 25 })
  public iconSize!: number;

  @Prop({ type: Number, default: 32 })
  public avatarSize!: number;

  @Prop({ type: String, default: '#0aadff' })
  public iconColor!: string;

  @Prop({ type: String, default: 'rgb(10, 173, 255, 0.1)' })
  public avatarColor!: string;

  @Prop({ type: Boolean, default: false }) public left!: boolean;
}
